import React from 'react';
import { motion } from 'framer-motion';

const SplitText = ({ text, className = '', as: Element = 'span', delayTime = 0.05, style = {} }) => {
  // Split the text into characters, preserving spaces
  const letters = text.split('');

  // Animation variants
  const container = {
    hidden: { opacity: 1 }, // Set initial opacity to 1 for no visual lag
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: delayTime, // Use delayTime for stagger delay
      },
    },
  };

  const child = {
    hidden: {
      opacity: 0,
      y: 20, // Move down initially
    },
    visible: {
      opacity: 1,
      y: 0, // Move to position
      transition: {
        duration: 0.4, // Animation duration for each letter
        ease: 'easeOut', // Smooth animation easing
      },
    },
  };

  return (
    <motion.div
      className={`split-text-container ${className}`}
      variants={container}
      initial="hidden"
      animate="visible"
      style={{
        display: 'flex',
        gap: '0.1em',
        flexWrap: 'wrap', 
      }}
    >
      {letters.map((letter, index) => (
        <motion.div
          key={index}
          variants={child}
          style={{
            display: 'inline-block',
            whiteSpace: letter === ' ' ? 'pre' : 'normal', // Ensure spaces are preserved
          }}
        >
          <Element style={{...style}}>{letter === ' ' ? '\u00A0' : letter}</Element> {/* Render spaces correctly */}
        </motion.div>
      ))}
    </motion.div>
  );
};

export default SplitText;
